export class EmitEvent {
    constructor(public command: any, public data?: any) {
    }
}
